module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Artistic0.937bbf3e.png";